import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Observable, Subscription, filter, fromEvent, lastValueFrom, map, pairwise, switchMap } from 'rxjs';
import { SearchResult } from '../../share/search-box/search-box.component';
import { FastAPIRepository } from 'src/app/repository/fast-api.repository';
import { FastAPIService, News } from 'src/app/service/fast-api.service';
import { NewsComponent } from '../../news/news.component';
import { FormControl } from '@angular/forms';
import { WordsegmentComponent } from 'src/app/components/nlp/wordsegment/wordsegment.component';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss']
})
export class SearchComponent implements OnInit{
  @ViewChild(WordsegmentComponent) wordsegmentComponent!: WordsegmentComponent;
  image_path = "assets/search-component-images/";
  list_icon_active = this.image_path + "list_icon_active.svg";
  list_icon_deactive = this.image_path + "list_icon_deactive.svg";
  box_icon_active = this.image_path + "box_icon_active.svg";
  box_icon_deactive = this.image_path + "box_icon_deactive.svg"
  list_icon = this.list_icon_deactive;
  box_icon = this.image_path + "box-icon.svg";
  result_corner_icon = this.image_path + "result-corner-icon.svg";
  view_icon = this.image_path + "view_icon.svg";
  mapPin_icon = this.image_path + "MapPin.svg"

  results: News[] = [];
  segmentedWords: string[] = [];
  resultsFound: number = 0;
  isHome = false;
  input_text: FormControl = new FormControl("");

  select = "เกี่ยวข้อง"

  notFound: boolean = false;
  showList = true;
  ready: boolean = true;
  input: string | null = null;
  routerSubscribe: Subscription | undefined;
  searchQuery: string = '';

  constructor(private route: ActivatedRoute, private router: Router, private fastService: FastAPIService, private location: Location) {
    this.routerSubscribe = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if(event.url.split(';')[0] == '/home/search') this.isHome = true;
        else  this.isHome = false;
        this.input = this.route.snapshot.paramMap.get('input');
        this.reloadData();
      }
    })
  }

  async reloadData() {
    if(!this.input) this.input = "*";
    this.input_text.setValue(this.input);
    this.results = [];
    this.loadingNews = true;
    this.start = 0;
    this.notFound = false;

    try {
      const response = await this.fastService.getSearchResult(this.input, this.start, this.rows, 'full', true);
      this.reachTheEnd = false;
      this.resultsFound = response.numFound;
      for(let news of response.newsList) {
        this.results.push(news);
      }
      this.start += this.rows;
      if (this.resultsFound === 0) {
        this.notFound = true;
      }
    } catch (error) {
      console.error('Search error:', error);
      this.notFound = true;
      this.resultsFound = 0;
    } finally {
      this.loadingNews = false;
    }
  }
  

  scrollSubscribe: Subscription | undefined;

  ngOnInit(): void {
    this.scrollSubscribe = fromEvent(window, 'scroll').pipe(
      map(() => window.scrollY),
      pairwise(),
      filter(([prev, curr]) => curr > prev)
    ).subscribe(scrollY => {
      if(this.loadingNews || this.results.length >= 30)  return;
      this.checkScrollEnd();
    })
//
    const savedShowList = localStorage.getItem('showList');
        if (savedShowList !== null) {
            this.showList = JSON.parse(savedShowList);
        } 
  }

  ngOnDestroy(): void {
    this.scrollSubscribe?.unsubscribe();
    this.routerSubscribe?.unsubscribe();
  }

  loadingNews: boolean = false;
  reachTheEnd: boolean = false;

  async checkScrollEnd() {
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const scrollTop = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0);

    if (windowHeight + scrollTop >= documentHeight - 300 && !this.reachTheEnd) {
      this.onMoreButtonClick();
    }
    
  }

  async onMoreButtonClick() {
    if(this.loadingNews)  return;
    this.loadingNews = true;
    await this.getMoreNews();
    this.loadingNews = false;
  }


  start = 0;
  rows = 10;
  async getMoreNews() {
    this.loadingNews = true;
    
    await this.fastService.getSearchResult(this.input ?? "", this.start, this.rows).then((response) => {
      this.start += this.rows
      if(response.newsList.length) {
        for(let news of response.newsList) {
          this.results.push(news);
        }
      }
      else this.reachTheEnd = true;
    })

    this.loadingNews = false;
  }

  onListButtonClick = async() => {
    this.showList = true;
    this.ready = false;
    this.ready = true;
    
    localStorage.setItem('showList', JSON.stringify(this.showList));
    //this.list_icon = this.list_icon_active;
  }

  async onSearch(input: string | null) {
    if(input) {
      this.searchQuery = input;
      this.fastService.currentQuestion = input;
      this.fastService.updateCurrentQuestion(input);
      if(!this.isHome) {
        this.router.navigate(['/search', { input: this.input_text.value }], {
          queryParams: { question: this.input_text.value }
        });
      } else {
        this.router.navigate(['/home/search', { input: this.input_text.value }], {
          queryParams: { question: this.input_text.value }
        });
      }
  
      if (this.wordsegmentComponent) {
        this.wordsegmentComponent.getNlp(input);
      }
    }
  }

  // onSegmentedWordsChange(words: string[]) {
  //   this.segmentedWords = words;
  // }


  async onAiSearch(input: string | null) {
    if (input) {
      this.searchQuery = input;
      this.fastService.currentQuestion = input;
      this.fastService.updateCurrentQuestion(input);
      if (!this.isHome) {
        this.router.navigate(['/ai_summary', { input: this.input_text.value }]);
      } else {
        this.router.navigate(['/home/ai_summary', { input: this.input_text.value }]);
      }
      
     
      if (this.wordsegmentComponent) {
        this.wordsegmentComponent.getNlp(input);
      }
    }
  }

  onBoxButtonClick = async() => {
    this.showList = false;
    this.ready = false;
    this.ready = true;
    localStorage.setItem('showList', JSON.stringify(this.showList));
    //this.list_icon = this.list_icon_deactive;
  }

  onSelectChange() {
    //Re order the results based on the option selected.
  }

  onResultClick(result: News) {
    const url = result.Link_OD;
    //console.log("searchQuery before setting:", this.searchQuery);
    this.searchQuery = this.input_text.value || ''; 
    //console.log("searchQuery after setting:", this.searchQuery);
  
    if (result.ScrapingType == 'Social-Media') {
      this.router.navigate(['/social-media', { id: encodeURIComponent(url) }], {
        queryParams: { searchQuery: this.searchQuery }
      });
    } else {
      this.router.navigate(['/news', { id: encodeURIComponent(url) }], {
        queryParams: { searchQuery: this.searchQuery }
      });
    }
  }

  getListIcon() {
    if(this.showList) return this.list_icon_active;
    else              return this.list_icon_deactive;
  }

  getBoxIcon() {
    if(this.showList) return this.box_icon_deactive;
    else              return this.box_icon_active;
  }

  goToMap(result: News) {
    const url = result.Link_OD;
    this.router.navigate(['map/', { link: result.Link_OD }])
  }

  onScroll(event: any) {
    console.log('0')
  }

  goBack() {
    this.location.back();
  }
}
